import React from 'react';
import Grid from "@material-ui/core/Grid";

import './style.scss';

const Method = () => {
    return(
        <Grid className="portfolioSingleDetails">
            <Grid className="container" container spacing={4}>
                <Grid item xs={12}>
                    <Grid className="prtMetaTop">
                        <h2><span>Our Method</span> </h2>
                        <p> Our Method, governed by local laws and regulations, drawing upon official CRA calculations, and giving you all the info you need to succeed.</p>
                    </Grid>
                </Grid>
                
                <Grid item xs={12}>
                    <Grid className="prtdRightContent">

                        <p>After years of serving our customers as a trusted pay stub provider, we have refined our method to offer you the most accurate, efficient and reliable platform possible. <br/> <br/> 

                            We use the Canada Revenue Agency (CRA) website for all of our calculations of deductions. The CRA is the ultimate authority that draws upon a reliable deductions calculator. We use the CRA calculator on our platform to provide accurate numbers so we can focus our efforts on providing you with services that aren’t already available for free.<br/> <br/> 
                            In addition to payroll deductions calculated by the CRA website, OneTwoPay services include:<br/> <br/> 

                            1) Pay statements that include all the required information<br/> 

                            2) Employer and employee profiles for quicker payroll entry<br/> 

                            3) A complete history of pay statements for all your employees<br/> <br/> 

                            We are always working to elevate our offerings and serve you better. As a OneTwoPay subscriber, you’ll be the first to know about new services. <br/> <br/> <br/> 
                        </p>
                        <h5>How We Use the CRA Calculator</h5>
                        <p>If you’re curious about who we draw upon the CRA’s reliable calculator, here is more on our process: <br/><br/>

                            1) Your payroll inputs are sent to the CRA website as you enter information into OneTwoPay.<br/>

                            2) Your deductions are received from the CRA site, combined with the information you entered.<br/>

                            3) Your pay stub is ready for you to preview, edit, download, and send to yourself via email.<br/><br/>

                            Important Note: To protect your privacy and to comply with Canada's federal and provincial privacy laws, OneTwoPay does not pass on any personally identifiable information to any third party including the CRA. We always replace the names provided by you with "OneTwoPay Customer" and "OneTwoPay Customer Employee".<br/><br/>

                            Finally, we do not maintain deductions formulas as part of our services and we don’t guarantee the accuracy of the deductions calculated.

                        </p>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    )
};

export default Method;